// extracted by mini-css-extract-plugin
module.exports = {"Answer":"AnswerBox_Answer__2Wanz","AnswerText":"AnswerBox_AnswerText__KUwTm","AnswerIntro":"AnswerBox_AnswerIntro__rvRkd","AnswerBox":"AnswerBox_AnswerBox__1A3Qu"};